import { render, staticRenderFns } from "./FooterAMP.vue?vue&type=template&id=9150a464&scoped=true&"
import script from "./FooterAMP.vue?vue&type=script&lang=js&"
export * from "./FooterAMP.vue?vue&type=script&lang=js&"
import style0 from "./FooterAMP.vue?vue&type=style&index=0&id=9150a464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9150a464",
  null
  
)

export default component.exports